import { Component, Input } from '@angular/core';
import { Params } from '@angular/router';

@Component({
  selector: 'planone-more-card',
  templateUrl: './more-card.component.html',
  styleUrls: ['./more-card.component.scss'],
})
export class MoreCardComponent {
  @Input() moreRouterLink: any[] | string | null | undefined;
  @Input() moreQueryParams: Params | null = null;
}
